// ============================================================================
// envBanner.js — jól látható jelzés a NEM éles változatokon.
//
// Cél: a tesztváltozatot soha ne lehessen összetéveszteni a kiadottal
// (például két telepített PWA-t egymás mellett használva). Az éles
// változaton semmi nem jelenik meg.
//
// A jelzés kattintásra érzéketlen (pointer-events: none), és nem mozdítja
// el a felület elemeit.
// ============================================================================

import { ENV } from "./env.js";

const BANNER_ID = "lineage0-env-banner";

/**
 * Kirajzolja a jelzést, ha nem éles a környezet. Többszöri hívás sem
 * hoz létre másodikat.
 * @param {Document} [doc]
 * @param {object} [env] csak a teszteknek: a vizsgált környezet (alapértelmezés: a csomagba fordított)
 * @returns {HTMLElement|null} a jelzés eleme, vagy null éles változaton
 */
export function renderEnvBanner(doc = document, env = ENV) {
  if (env.name === "prod") return null;

  const existing = doc.getElementById(BANNER_ID);
  if (existing) return existing;

  const el = doc.createElement("div");
  el.id = BANNER_ID;
  el.setAttribute("aria-hidden", "true");
  // A felirat (2026-10-10, tagi kérés): a DEV / projektnév jelzés helyett csak "Lineage Zero".
  // A VERZIÓ SZÁNDÉKOSAN NINCS a sávon (2026-10-08, tagi jelzésre): a hosszabb szöveg telefonon két sorba
  // tört, és eltakarta a fejléc gombjait (keresés, cetli, admin, profil). A futó verzió a profil
  // legalján látszik (adminView.js). Itt csak a környezet neve van.
  el.textContent = "Lineage Zero";
  el.style.cssText = [
    "position:fixed",
    "top:env(safe-area-inset-top,0px)",
    "left:50%",
    "transform:translateX(-50%)",
    "z-index:2147483647",
    // Egy sor, és olyan alacsony (11 px), hogy beleférjen a fejléc felső belső margójába (12 px + a
    // biztonságos sáv): így a gombokat SEHOL nem takarja, bármilyen széles a képernyő.
    "box-sizing:border-box",
    "padding:0 8px",
    "max-width:calc(100vw - 16px)",
    "white-space:nowrap",
    "overflow:hidden",
    "text-overflow:ellipsis",
    "font:600 9px/11px system-ui,sans-serif",
    "letter-spacing:.06em",
    `background:${env.themeColor || "#e8710a"}`,
    "color:#fff",
    "border-radius:0 0 6px 6px",
    "opacity:.92",
    "pointer-events:none",
    "user-select:none",
  ].join(";");
  doc.body.appendChild(el);
  return el;
}
